"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SurveyService = void 0;
var _surveyor = require("../controllers/surveyor.controller");
var SurveyService = {
  surveys: _surveyor.config.root + "/survey/public/login",
  details: _surveyor.config.root + "/survey/public/details",
  // forgotPassword: config.root + "/survey/public/forgot-passcode/mail",
  forgotPassword: _surveyor.config.root + "/survey/public/send-magic-link",
  expiryMagicLinkPassword: _surveyor.config.root + "/survey/public/magic-link/mail",
  // expiryMagicLinkPassword: config.root + "/survey/send-magic-link",
  emailProvider: _surveyor.config.root + "/survey/donors/email",
  publicDetails: _surveyor.config.root + "/survey/public",
  metadata: _surveyor.config.root + "/survey/render/metadata",
  surveyRendering: {
    rendering: _surveyor.config.root + "/survey/render",
    tab: _surveyor.config.root + "/survey/render/update/tab",
    goToFund: _surveyor.config.root + "/survey/render/gotofund",
    surveyLatest: _surveyor.config.root + "/survey/render/latest"
  },
  read: _surveyor.config.root + "/survey/recipient/response",
  configuration: {
    get: _surveyor.config.root + "/survey/render/configuration",
    fetch: _surveyor.config.root + "/survey/render/response",
    save: _surveyor.config.root + "/survey/render/response",
    fundList: _surveyor.config.root + "/recipient/fund/list",
    impactList: _surveyor.config.root + "/impact/type/list"
  }
};
exports.SurveyService = SurveyService;